import moment from "moment";
import { FunctionField, Show, SimpleShowLayout, TextField } from "react-admin";
import CustomReferenceField from "../Common/CustomReferenceField";

const RenewalsMetaShow = () => {
  return (
    <Show actions={false}>
      <div style={{ display: "grid", gridTemplateColumns: "30% 40% 30%" }}>
        <SimpleShowLayout>
          <TextField label="Id" source="id" />
          <FunctionField label="Created At" render={(record: any) => record?.createdAt ? moment(record.createdAt).format('DD MMM YYYY, hh:mm:ss A') : '-'} />
          <FunctionField label="Updated At" render={(record: any) => record?.updatedAt ? moment(record.updatedAt).format('DD MMM YYYY, hh:mm:ss A') : '-'} />
          <CustomReferenceField
            label="House Id"
            listName={"Houses"}
            source={"houseId"}
          />
          <TextField label="End Date" source="endDate" />
          <TextField label="Active PR" source="hasActivePr" />
          <TextField label="Escalation" source="hasEscalations" />
        </SimpleShowLayout>
      </div>
    </Show>
  );
};

export default RenewalsMetaShow;
